import { Link } from 'react-router-dom'

interface BottomListItem {
	id: number
	image: string
	link: string
	title: string
}

interface BottomListProps {
	activeHandler: (item: BottomListItem) => string | undefined
	items: BottomListItem[]
}

export function BottomList({ activeHandler, items }: BottomListProps) {
	if (!items || items.length === 0) return null

	return (
		<ul className='list'>
			{items.map(item => (
				<li
					className={`text-list ${activeHandler(item)}`}
					key={item.id}
				>
					<Link className='text-list' to={item.link}>
						<div className='line-list__img-container'>
							<img alt='pageIcon' src={item.image} />
						</div>
						{item.title}
					</Link>
				</li>
			))}
		</ul>
	)
}
